import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// import { Params, ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from 'projects/services/src/app/API/payment.service';
import { StorageService } from 'projects/services/src/app/storage.service';
const PAYMENT_STATUS = Object.freeze({
	LOADING: 'loading',
	SUCCESS: 'success',
	FAILED: 'failed'
});

@Component({
	selector: 'app-thankyou-payment',
	templateUrl: './thankyou-payment.component.html',
	styleUrls: ['./thankyou-payment.component.css']
})
export class ThankyouPaymentComponent implements OnInit {
	@Input() paymentId: string;
	@Output() statusChange = new EventEmitter();
	@Output() STATUS_LIST = new EventEmitter();
	paymentDetails: any = {};
	constructor(
		private paymentService: PaymentService,
	) {
	}

	ngOnInit() {
		this.STATUS_LIST.emit(this.STATUS);
		this.paymentService.getPaymentDetails(this.paymentId)
			.subscribe(res => {
				this.paymentDetails = res.data;
				this.statusChange.emit(this.status);
			}, err => {
				console.log(err);
			});
	}

	get STATUS() {
		return PAYMENT_STATUS;
	}

	get status() {
		switch (this.paymentDetails.isComplete) {
			case true:
				return PAYMENT_STATUS.SUCCESS;
			case false:
				return PAYMENT_STATUS.FAILED;
			default:
				return PAYMENT_STATUS.LOADING;
		}

	}

}
